function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    // this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    console.log('Here');
    console.log(this);
    this.updateOptions();
    this.updateMasterId();
//     this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (modalContent) {
      const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
      modalContent.prepend(newMediaModal);
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
         // this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

//   toggleAddButton(disable = true, text, modifyClass = true) {
//     const productForm = document.getElementById(`product-form-${this.dataset.section}`);
//     if (!productForm) return;
//     const addButton = productForm.querySelector('[name="add"]');
//     const addButtonText = productForm.querySelector('[name="add"] > span');

//     if (!addButton) return;

//     if (disable) {
//       addButton.setAttribute('disabled', 'disabled');
//       addButton.classList.add("btn__sold-out");
//        document.getElementById('klaviyo__custom').classList.add("klaviyo__custom");
//       document.getElementsByClassName( 'product-form__submit' )[0].style.display = 'none';
     
//     } else {
//       addButton.removeAttribute('disabled');
//       addButton.classList.remove("btn__sold-out");
//       document.getElementsByClassName( 'product-form__submit' )[0].style.display = 'block';
//       document.getElementById('klaviyo__custom').classList.remove("klaviyo__custom");
      
//     }

//     if (!modifyClass) return;
//   }
  


  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

$('li.has-mega').mouseover(function() {
  $(this).find('.mega-menu').attr('open','');
});
$('li.has-mega').mouseleave(function() {
  var menn=$(this).find('.mega-menu');
  setTimeout(function(){
  if($(".mega-menu__content:hover").length != 0){
//     alert("Mouse is Over the DIV Element.");
  } else{
//     alert('bing');
      menn.removeAttr('open');
  }
  },1000);
});
$('.mega-menu .mega-menu__content').mouseover(function() {
$(this).parents('.mega-menu').attr('open','');
});
$('.mega-menu .mega-menu__content').mouseleave(function() {
$(this).parents('.mega-menu').removeAttr('open');
});
$(document).ready(function(){
  $('.sound-switcher').click(function(){
    var video='.'+$(this).data('block');
	if($(this).hasClass('off')){
      $(this).toggleClass('off');
      $(this).toggleClass('on');
      $(this).find('.sound-action').text('SOUND OFF');
      $(video).prop('muted', false);
    }else{
      $(this).toggleClass('off');
      $(this).toggleClass('on');
      $(this).find('.sound-action').text('SOUND ON');
      $(video).prop('muted', true);
    }
  });

  setTimeout(function() {
    $(document).on('change','input[name="Color"]',function(){
      var parent_var = $(this).parents(".product__info-container");
      var color=$(this).val();
      console.log(color);
      parent_var.find('label').removeClass('not-available');
      parent_var.find('label').removeClass('available');
      
      parent_var.find('input[name="Size"]').each(function(){
        var vari= color + ' / '+ $(this).val();
        var id=$(this).attr('id');
        vari = vari.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
        var checkAvail=parent_var.find('.vari-'+vari).val();
        console.log("Paksha"+checkAvail);
        console.log("yaha "+id+' '+checkAvail + vari);

        if(parent_var.find('.vari-'+vari).length) {
          parent_var.find('#label-'+id).show();
          if(checkAvail == "false"){
            parent_var.find('#label-'+id).addClass('not-available');
          }else{
            parent_var.find('#label-'+id).addClass('available');
          }
          parent_var.find('.available:first').trigger('click');
        }else{
          parent_var.find('#label-'+id).hide();
        }
      });
      
      $('.color-value').text(color);

      if ($(window).width() < 768) {
        $(".thumbnail-list__item").hide();
        var count = 1;
        
        $(".thumbnail-list__item").each(function(){
          var dotdata = $(this).data('alt');
          if (dotdata.indexOf(color) >= 0){
            $(this).show();
            $(".thumbnail-list.dots").find(".thumbnail-list__item").removeClass("first-dots"+count);
            $(".thumbnail-list.dots").find(".thumbnail-list__item").removeClass("fill-dots");
            $(this).addClass("first-dots"+count);
            count +=1;
          }
        });
      }
    
      var count = 0;
      var slide = '';
      var myarray = [];
      $(".product-images-slider").each(function(){
        var parent_id = $(this);
        parent_id.find(".featured-product-image").each(function(){
          var dotdata = $(this).data('alt');
          if (dotdata.indexOf(color) >= 0){
            count +=1;
            myarray.push($(this).data('slick-index'));
          }
        });
      });
      $(".product-images-slider").slick('slickGoTo', myarray[0]);
    });
  }, 1);

  $('.product__info-container').each(function(){
    var parent_id = $(this);
    var color=parent_id.find('input[name="Color"]:checked').val();
    
    parent_id.find('input[name="Size"]').each(function(){
      var vari= color + ' / '+ $(this).val();
      var id=$(this).attr('id');
      vari = vari.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
      var checkAvail=parent_id.find('.vari-'+vari).val();
      console.log(id+' '+checkAvail + vari);
    
      if(parent_id.find('.vari-'+vari).length) {
        parent_id.find('#label-'+id).show();
        if(checkAvail == "false"){
          parent_id.find('#label-'+id).addClass('not-available');
        }else{
          parent_id.find('#label-'+id).addClass('available');
        }
      }else{
        parent_id.find('#label-'+id).hide();
      }
    });

    // show relevant variant images on the product page and hide others
    let slide_count = 1;
    $('.product__media.media img').each(function(){
      let altTag=$(this).attr('alt');
      // console.log({ altTag });
      if (altTag.indexOf(color) > -1) {
        $(this).parents('.product__media-item').show();
     
        if (slide_count == 1){
          $(this).parents('.product__media-item').addClass('slide-active first-slide');
          slide_count = slide_count + 1;
        } else {
          $(this).parents('.product__media-item').addClass('slide-active');
        }
      } else{
        if (containers_count < 2 && inputs != 1 && !('bundle-product')) {
        $(this).parents('.product__media-item').hide();
        $(this).parents('.product__media-item').removeClass('slide-active');
        $(this).parents('.product__media-item').removeClass('slide-active first-slide');
        }
      }
    });

    $('.product-media-modal.media-modal .product-media-modal__content img').each(function(){
      let altTag=$(this).attr('alt');
      if (altTag.indexOf(color) > -1) {
        $(this).show();
      } else{
        $(this).hide();        
      }
    });

    $('.color-value').text(color);
    $(".thumbnail-list__item").hide();
    // var color = $(this).val();
    var count = 1;
    $(".thumbnail-list__item").each(function(){
      var dotdata = $(this).data('alt');
      if (dotdata.indexOf(color) >= 0){
        $(this).show();
        $(".thumbnail-list.dots").find(".thumbnail-list__item").removeClass("first-dots"+count);
        $(".thumbnail-list.dots").find(".thumbnail-list__item").removeClass("fill-dots");
        $(this).addClass("first-dots"+count);
        count +=1;
      }
    })
  });
  
//   $('.slideshow__text').click(function(){
//     $('video.mobile-img').trigger('play');
//   });
});

$.fn.is_on_screen = function(){
  var win = $(window);
  var viewport = {
    top : win.scrollTop(),
    left : win.scrollLeft()
  };
  viewport.right = viewport.left + win.width();
  viewport.bottom = viewport.top + win.height();

  var bounds = this.offset();
  bounds.right = bounds.left + this.outerWidth();
  bounds.bottom = bounds.top + this.outerHeight();

  return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
};

$(window).on('resize scroll', function() {
  if ($(".product.product--medium")[0]){
    if( $('.product.product--medium').is_on_screen()  ) {
      $('.sticky_cart').addClass("hidee");
      if(($('.product__description').is_on_screen()) && !($('.product-form .product-form__buttons').is_on_screen() )){
        $('.sticky_cart').removeClass("hidee");
      }
    } else {
      $('.sticky_cart').removeClass("hidee");
    }
  }
});

/* Start code section to handle side minicart */
function getSectionsToRender() {
  return [
    {
      id: 'cart-icon-bubble',
      section: 'cart-icon-bubble',
      selector: '.shopify-section'
    },
  ];
}

function getSectionInnerHTML(html, selector) {
  return new DOMParser()
    .parseFromString(html, 'text/html')
    .querySelector(selector).innerHTML;
}

function showSideMinicartLoading() {
  $('#minicart-custom-list .loading-overlay').show();
}

function hideSideMinicartLoading() {
  $('#minicart-custom-list .loading-overlay').hide();
}

function buildSideMiniCart() {
  $('.boost-pfs-subtotal .boost-pfs-subtotal-price').text('');
  $('.boost-pfs-minicart-top').html(`
    <ol id="minicart-custom-list">
      <div class="loading-overlay">
        <div class="loading-icon">Updating cart...</div>
      </div>
    </ol>
  `);
  
  jQuery.getJSON('/cart.js', function(cart) {
    if (cart.items.length === 0) {
      $('.boost-pfs-minicart-bottom').hide();
      $('.boost-pfs-minicart-top').html('<div class="boost-pfs-minicart-empty">Your Cart Is Currently Empty</div>');
    } else {
      $('.boost-pfs-minicart-bottom').show();
    }

    $('.boost-pfs-minicart-title .boost-pfs-count-item').text(cart.item_count.toString());
    $('.boost-pfs-subtotal .boost-pfs-subtotal-price').text(`${(cart.total_price / 100.0).toFixed(2)} ${cart.currency}`);
    
    $.each(cart.items, function(index, item) {
      const isFreeItem = item.line_price === 0;

      $('#minicart-custom-list').append(`
        <li class="boost-pfs-minicart-item boost-pfs-minicart-item-${item.id}">
          <a href="${item.url}" title="${item.product_title}" class="boost-pfs-minicart-item-image">
            <img src="${item.image}" alt="${item.product_title}">
          </a>
          <div class="boost-pfs-minicart-item-details">
              <div class="boost-pfs-minicart-item-details-inner">
                  <div class="boost-pfs-minicart-item-group-title">
                      <p class="boost-pfs-minicart-item-name">
                          <a href="${item.url}">${item.product_title}</a>
                      </p>
                      <p class="boost-pfs-minicart-item-vendor">${item.vendor}</p>
                      <div class="boost-pfs-minicart-item-options item-options-${item.id}"></div>
                      ${isFreeItem ? '' : `<button title="Remove this item" class="boost-pfs-minicart-item-remove" data-variant-id="${item.id}">
                        <span class="boost-pfs-minicart-item-remove-icon"></span>
                        <span class="boost-pfs-minicart-item-remove-text">×</span>
                      </button>`}
                  </div>
                  <div class="boost-pfs-minicart-item-group-price">
                    <div class="boost-pfs-minicart-item-price"><span class="money">${(item.price / 100.0).toFixed(2)} ${cart.currency}</span></div>
                    ${isFreeItem 
                      ? `<span><span>Free x${item.quantity}<span><span>`
                      : `<div class="boost-pfs-minicart-item-collateral">
                        <div class="boost-pfs-minicart-item-quantity-wrapper">
                          <button data-minus-qtt="${item.id}" class="boost-pfs-minicart-item-quantity-minus">-</button>
                          <input class="boost-pfs-minicart-item-quantity" readonly type="number" name="updates[]" id="" value="${item.quantity}" min="0" aria-label="Item quantity" data-variant-id="${item.id}" role="textbox">
                          <button data-plus-qtt="${item.id}" class="boost-pfs-minicart-item-quantity-plus">+</button>
                        </div>
                        <span class="boost-pfs-minicart-item-line">x</span>
                        <span class="boost-pfs-minicart-item-price"><span class="money">${(item.price / 100.0).toFixed(2)} ${cart.currency}</span></span>
                      </div>
                      <div class="boost-pfs-minicart-item-sub-total-price">${(item.price / 100.0).toFixed(2)} ${cart.currency}</div>`
                    }
                  </div>
              </div>
          </div>
        </li>
      `);

      $.each(item.options_with_values, function(index, optionWithValue){
        if (optionWithValue.name.toLowerCase() === 'title') return;

        $(`#minicart-custom-list .boost-pfs-minicart-item-options.item-options-${item.id}`).append(`
          <div class="boost-pfs-minicart-item-option-element">
            <span class="boost-pfs-minicart-item-option-name">${optionWithValue.name}: </span>
            <span class="boost-pfs-minicart-item-option-value">${optionWithValue.value}</span>
          </div>
        `);
      });
    });

    $('.boost-pfs-minicart-item-remove').on('click', (event) => {
      const variantId = event.currentTarget.dataset['variantId'];
      const itemToDelete = cart.items.find(item => item.id.toString() === variantId);

      if (!itemToDelete) return;

      showSideMinicartLoading();
      const productType = itemToDelete.product_type?.toLowerCase();
      const cartUpdateData = {
        quantity: 0,
        id: itemToDelete.id,
        sections: "cart-icon-bubble"
      };

      $.post('/cart/change.js', cartUpdateData, function(result){
        if (productType == "jackets" || productType == "legacy" || productType == "raincoats" || productType == "outerwear"){
          $.get('/products/garment-bag.js', function(bag){
            $.get('/products/gift-box.js', function(gift){
              const updateData = {
                updates: {
                  [bag.variants[0].id]: 0,
                  [gift.variants[0].id]: 0,
                },
                sections: "cart-icon-bubble",
              };

              $.post('/cart/update.js', updateData, function(result) {
                getSectionsToRender().forEach((section => {
                  const elementToReplace =
                    document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        
                  elementToReplace.innerHTML =
                    getSectionInnerHTML(result.sections[section.section], section.selector);
                }));

                let count = 0;
                jQuery.getJSON('/cart.js', function(cart) {
                  $.each(cart.items, function(index, item){
                    if(item.product_type == "Raincoats" ||item.product_type == "Jackets" || item.product_type == "Legacy" ||item.product_type == "Outerwear" ){
                      count += item.quantity;
                    }
                  });

                  const addData = {
                    items: [
                      {
                       id: bag.variants[0].id,
                       quantity: count
                      },
                      {
                       id: gift.variants[0].id,
                       quantity: count
                      },
                    ],
                    sections: "cart-icon-bubble"
                  }

                  $.post('/cart/add.js', addData, function(freeItemsAddedResult){
                    getSectionsToRender().forEach(section => {
                      const elementToReplace =
                        document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            
                      elementToReplace.innerHTML =
                        getSectionInnerHTML(freeItemsAddedResult.sections[section.section], section.selector);
                    });

                    buildSideMiniCart();
                    hideSideMinicartLoading();
                  }, 'json');
                });
              }, 'json');

            }, 'json');
          }, 'json');
        } else {
          getSectionsToRender().forEach(section => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
  
            elementToReplace.innerHTML =
              getSectionInnerHTML(result.sections[section.section], section.selector);
          });
          
          buildSideMiniCart();
          hideSideMinicartLoading();
        }
      }, 'json');
    });

    $('.boost-pfs-minicart-item-quantity-minus').on('click', function(event){
      event.stopPropagation();
      event.preventDefault();

      const variantId = event.currentTarget.dataset['minusQtt'];
      const itemToUpdate = cart.items.find(item => item.id.toString() === variantId);

      if (!itemToUpdate) return;

      showSideMinicartLoading();
      const productType = itemToUpdate.product_type?.toLowerCase();
      const cartDataToUpdate = {
        id: itemToUpdate.id,
        quantity: itemToUpdate.quantity - 1,
        sections: "cart-icon-bubble",
      };

      $.post('/cart/change.js', cartDataToUpdate, function(cart){        
        if(productType == "jackets" || productType == "legacy" || productType == "raincoats" || productType == "outerwear"){
          let count = 0;

          $.each(cart.items, function(index, item){
            if(item.product_type == "Raincoats" || item.product_type == "Jackets" || item.product_type == "Legacy" || item.product_type == "Outerwear" ){
              let toAdd = item.quantity;
              count += toAdd;
            }
          });
      
          $.get('/products/garment-bag.js',function(bag){
            $.get('/products/gift-box.js',function(gift){

              const updateData = {
                updates: {
                  [bag.variants[0].id]: count,
                  [gift.variants[0].id]: count,
                },
                sections: "cart-icon-bubble",
              };

              $.post('/cart/update.js', updateData, function(result) {                
                getSectionsToRender().forEach((section => {
                  const elementToReplace =
                    document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        
                  elementToReplace.innerHTML =
                    getSectionInnerHTML(result.sections[section.section], section.selector);
                }));
                
                buildSideMiniCart();
                hideSideMinicartLoading();
              }, 'json');

            }, 'json');
          }, 'json');
        } else {
          getSectionsToRender().forEach(section => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
  
            elementToReplace.innerHTML =
              getSectionInnerHTML(cart.sections[section.section], section.selector);
          });
          
          buildSideMiniCart();
          hideSideMinicartLoading();
        }
      }, 'json');
    });

    $('.boost-pfs-minicart-item-quantity-plus').on('click', function(event){
      event.stopPropagation();
      event.preventDefault();

      const variantId = event.currentTarget.dataset['plusQtt'];
      const itemToUpdate = cart.items.find(item => item.id.toString() === variantId);

      if (!itemToUpdate) return;
      
      showSideMinicartLoading();
      const productType = itemToUpdate.product_type?.toLowerCase();
      const cartDataToUpdate = {
        id: itemToUpdate.id,
        quantity: itemToUpdate.quantity + 1
      };
      
      $.post('/cart/change.js', cartDataToUpdate, function(cart){        
        if(productType == "jackets" || productType == "legacy" || productType == "raincoats" || productType == "outerwear"){
          let count = 0;

          $.each(cart.items, function(index, item){
            if(item.product_type == "Raincoats" || item.product_type == "Jackets" || item.product_type == "Legacy" || item.product_type == "Outerwear" ){
              let toAdd = item.quantity;
              count += toAdd;
            }
          });
      
          $.get('/products/garment-bag.js', function(bag){
            $.get('/products/gift-box.js', function(gift){

              const updateData = {
                updates: {
                  [bag.variants[0].id]: count,
                  [gift.variants[0].id]: count,
                },
                sections: "cart-icon-bubble",
              };
              
              $.post('/cart/update.js', updateData, function(result) {                
                getSectionsToRender().forEach((section => {
                  const elementToReplace =
                    document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        
                  elementToReplace.innerHTML =
                    getSectionInnerHTML(result.sections[section.section], section.selector);
                }));
                
                buildSideMiniCart();
                hideSideMinicartLoading();
              }, 'json');

            }, 'json');
          }, 'json');
        } else {
          buildSideMiniCart();
          hideSideMinicartLoading();
        }
      }, 'json');
    });
  });

}
/* End code section to handle side minicart */

$( document ).ready(function() {
  $('.header__icon--cart').on('click', () => {
    buildSideMiniCart();
  });

$('.product__info-container').each(function(){
  var parent_id = $(this);
  
  var colorInput = parent_id.find('input[name="Color"]:checked');
  var sizeInput = parent_id.find('input[name*="Size"]:checked');
  console.log(sizeInput)
  // Check if both color and size inputs are found
  if (colorInput.length == 1 && sizeInput.length == 1) {
    var variant_color = colorInput.val().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    var variant_size = sizeInput.val().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    var checked_id = "vari-"+variant_color+"-"+variant_size;
  } else {
    var checked_id = "vari-";
    
    sizeInput.each(function() {
        checked_id += $(this).val().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '') + '-';

    });
    checked_id = checked_id.slice(0,-1)
  }
    console.log(checked_id);

    if(parent_id.find("."+checked_id).val() == "true"){
      parent_id.find(".klaviyo-bis-trigger").removeClass("waitlist-block");
      parent_id.find(".klaviyo-bis-trigger").addClass("waitlist-none");
      parent_id.find(".klaviyo-bis-trigger").hide();
      parent_id.find(".product-form__submit").show();
    } else if(parent_id.find("."+checked_id).val() == "false"){
      parent_id.find(".product-form__submit").hide();
      parent_id.find(".klaviyo-bis-trigger").show();
      parent_id.find(".klaviyo-bis-trigger").addClass("waitlist-block");
      parent_id.find(".klaviyo-bis-trigger").removeClass("waitlist-none");
    }
  
});
  
$(document).on('change','input[name="Color"]',function(){
  var parent_id = $(this).parents(".product__info-container");
  var variant_size = parent_id.find('input[name="Size"]:checked').val().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
  var variant_color = $(this).val().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
  console.log(variant_color);
  var checked_id = "vari-"+variant_color+"-"+variant_size;
  console.log(checked_id);
  if(parent_id.find("."+checked_id).val() == "true"){
    parent_id.find(".klaviyo-bis-trigger").removeClass("waitlist-block");
    parent_id.find(".klaviyo-bis-trigger").addClass("waitlist-none");
    parent_id.find(".klaviyo-bis-trigger").hide();
    parent_id.find(".product-form__submit").show();
  }else{ if(parent_id.find("."+checked_id).val() == "false"){
    parent_id.find(".product-form__submit").hide();
    parent_id.find(".klaviyo-bis-trigger").show();
    parent_id.find(".klaviyo-bis-trigger").addClass("waitlist-block");
    parent_id.find(".klaviyo-bis-trigger").removeClass("waitlist-none");
  }
       }
});
  
$(document).on('change','input[name="Size"]',function(){
  var parent_id = $(this).parents(".product__info-container");
  var variant_color = parent_id.find('input[name="Color"]:checked').val().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
  var variant_size = $(this).val().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
  console.log(variant_size);
   var checked_id = "vari-"+variant_color+"-"+variant_size;
  console.log(checked_id);
  if(parent_id.find("."+checked_id).val() == "true"){
    parent_id.find(".klaviyo-bis-trigger").removeClass("waitlist-block");
    parent_id.find(".klaviyo-bis-trigger").addClass("waitlist-none");
    parent_id.find(".klaviyo-bis-trigger").hide();
    parent_id.find(".product-form__submit").show();
  }else{ if(parent_id.find("."+checked_id).val() == "false"){
    parent_id.find(".product-form__submit").hide();
    parent_id.find(".klaviyo-bis-trigger").show();
    parent_id.find(".klaviyo-bis-trigger").addClass("waitlist-block");
    parent_id.find(".klaviyo-bis-trigger").removeClass("waitlist-none");
  }
       }
});
  
  });
$(".thumbnail-list.dots").find(".thumbnail-list__item").click(function(){
    $(".thumbnail-list.dots").find(".thumbnail-list__item").removeClass("fill-dots");
  $(".thumbnail-list.dots").find(".thumbnail-list__item").removeClass("first-dots1");
    $(this).addClass("fill-dots");
});

  $(document).on('click','.quick-add-modal__content-info #klaviyo__custom',function(e){
    e.preventDefault();
    var vari=$('.quick-add-modal__content-info product-form input[name="id"]').val();
    $('.osp-option-'+vari).prop('selected', true);
    $('.quick-add-modal__content-info .out-of-stock-popup').show();
    
  });
  $(document).on('click','.quick-add-modal__content-info .out-of-stock-popup .close-popup',function(){
    $('.quick-add-modal__content-info .out-of-stock-popup').hide();
  });
$(document).on('click','#outOfStockButton',function(){
    var productID=$('#outOfStockProduct').val();
    var variantID=$('#outOfStockVariant').val();
    var userMail=$('#outOfStockEmail').val();
    $.ajax({
      type: "POST",
      url: "https://a.klaviyo.com/onsite/components/back-in-stock/subscribe",
      data: {
        a: "Ja6Z8m",
        email: userMail,
        variant: variantID,
        product: productID, // Product must be present in Klaviyo catalog to record event.
        platform: "shopify"
      },
      success: function(response){
        if(response.success){
          $('#completed_message').show();
          $('.popup-button').hide();
        }
      }
    })
});

$(document).ready(function(){
  $(window).scrollTop(0);
  if ($('.design-feature-section ul li').length < 1) {
    $('.design-feature-section').addClass('make-none');
  } else {
    $('.design-feature-section').removeClass('make-none');
  }
});